import { SxProps, Theme } from '@mui/material'

/** Soft gray fill used for read-only value boxes on the order details page. */
export const READ_ONLY_FIELD_BG = '#F0F2F5'
export const READ_ONLY_VALUE_COLOR = '#000000'
export const EDITABLE_VALUE_COLOR = '#000000'

/** MUI TextField / Autocomplete input styles for view (read-only) mode. */
export const readOnlyTextFieldSx: SxProps<Theme> = {
  opacity: 1,
  '& .MuiOutlinedInput-root': {
    backgroundColor: READ_ONLY_FIELD_BG,
    borderRadius: '8px',
    opacity: 1,
    '& fieldset': {
      border: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: READ_ONLY_FIELD_BG,
      opacity: 1,
      WebkitTextFillColor: READ_ONLY_VALUE_COLOR,
      '& fieldset': {
        border: 'none',
      },
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '& .MuiInputBase-input': {
    color: READ_ONLY_VALUE_COLOR,
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: READ_ONLY_VALUE_COLOR,
    color: READ_ONLY_VALUE_COLOR,
    opacity: 1,
  },
  // Keep Autocomplete end adornments from looking interactive in view mode
  '& .MuiAutocomplete-endAdornment': {
    display: 'none',
  },
}

/** Applied on Autocomplete root so MUI disabled opacity does not wash out values. */
export const readOnlyAutocompleteSx: SxProps<Theme> = {
  opacity: 1,
  '&.Mui-disabled': {
    opacity: 1,
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    opacity: 1,
  },
}
